import * as _ from 'lodash';

import { plural } from '../../../../shared/helpers';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { ProjectsFilter } from '../../../../shared/projectsV2';

import { getTeamQueryKey } from './useTeam';

type AddProjectsToTeamVariables = {
  teamId: number;
  projectIds: string[] | 'all';
  filters?: ProjectsFilter;
};

//  Actual function to add projects to a team
async function addProjectsToTeam({ teamId, projectIds, filters }: AddProjectsToTeamVariables) {
  const response = await put(`/api/teams/${teamId}/projects`, { projects: projectIds, action: 'add', filters });
  return response.data;
}

/**
 * Hook for adding projects to a team.
 */
export default function useAddProjectsToTeam() {
  return useToastedMutation({
    mutationFn: addProjectsToTeam,
    successToastMessage: (_response, variables: AddProjectsToTeamVariables) => {
      const count = Array.isArray(variables.projectIds) ? variables.projectIds.length : 'all';
      return `Added ${count} ${plural(_.isNumber(count) ? count : 0, 'project')} to team.`;
    },
    errorToastMessage: 'Failed to add projects to team.',
    onSuccess: (_response, variables: AddProjectsToTeamVariables) => {
      // Re-fetch the team to get updated projects
      queryClient.invalidateQueries({ queryKey: getTeamQueryKey(variables.teamId) });
    },
  });
}
